import { EXPRESS_API } from 'configs/api/expressApi';
import { useQuery } from 'react-query';
import { pronunciationKeys } from './pronunciationKeys';
import { useToastError } from 'lib/hooks';
import { PaginationConstants } from 'lib/const/PaginationConstants';
import { PRONUNCIATIONS_SORT_KEYS } from 'app/pages/ai-configuration/personalization/pronunciations/constants';

export const CustomerPhoneticTypes = {
  DEALERSHIP_NAME: 'DEALERSHIP_NAME',
  SALESMAN_NAME: 'SALESMAN_NAME',
  OTHER: 'OTHER',
} as const;

export type CustomerPhoneticType =
  (typeof CustomerPhoneticTypes)[keyof typeof CustomerPhoneticTypes];

export interface IPronunciation {
  id: number;
  customerId: number;
  userId: number;
  text: string;
  audioS3Url: string;
  type: CustomerPhoneticType | null;
}
export interface IPronunciationResponse {
  customerPhonetics: IPronunciation[];
  count: number;
}

export interface IPronunciationSortingParams {
  sortKey: PRONUNCIATIONS_SORT_KEYS | null;
  order: PaginationConstants.ASCENDING | PaginationConstants.DESCENDING;
  start: number;
  limit: number;
}

const getPronunciations = async (
  params: IPronunciationSortingParams
): Promise<IPronunciationResponse> => {
  const response = await EXPRESS_API.get('/customer-phonetics', {
    params,
  });
  return response.data;
};

export const useQueryPronunciations = (params: IPronunciationSortingParams) => {
  const { showError } = useToastError();

  return useQuery(
    pronunciationKeys.list(params),
    () => getPronunciations(params),
    {
      onError: error =>
        showError(error || `An error occurred while fetching pronunciations.`),
    }
  );
};
